import { SvgIcon, SvgIconProps } from '@mui/material';

type ChevronUpIconProps = Omit<SvgIconProps, 'width' | 'height'> & {
  width?: number | string;
  height?: number | string;
};

export const ChevronUpIcon = ({ width = 16, height = 16, sx, ...props }: ChevronUpIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 16 16"
    fill="none"
    sx={[
      {
        width,
        height,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <path
      d="M12 6L8 10L4 6"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
